import * as Highcharts from 'highcharts';
import {ChartTemplateService} from '../../../../cockpit/cockpit-shared/charts-templates/chart-template.service'; // NOSONAR
import {CockpitCard} from 'shared/dtos/cockpit-card'; // NOSONAR
import {SeriesAbsolutPerc} from 'shared/dtos/cockpit/charts/seriesAbsolutPerc'; // NOSONAR
import {GesamtverdienstUndLohnbestandteile} from '../../../../shared/dtos/cockpit/gesamtverdienst-und-lohnbestandteile'; // NOSONAR
import {
  ABSOLUT,
  ANTEIL,
  GESTAPELT,
  UNGESTAPELT
} from '../../../../shared/EnumsConstants/card-charts-translate-keys.enum'; // NOSONAR
import {DataStorageService} from '../../../../shared/services/data-storage.service'; // NOSONAR
import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {Cockpit} from 'shared/dtos/cockpit/cockpit';
import {TableExportService} from '../../../../shared/services/table-data-export/table-data-export.service';
import {CockpitContentComponent} from '../../cockpit-content-component';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';

@Component({
  selector: 'app-gesamtverdienst-lohnbestandteile',
  templateUrl: './chart-dialog-gesamtverdienst-lohnbestandteile.component.html',
  styleUrls: [
    '../../card/card.component.scss',
    './chart-dialog-gesamtverdienst-lohnbestandteile.component.scss'
  ],
  providers: [ChartTemplateService],
  standalone: false
})
export class ChartDialogGesamtverdienstLohnbestandteileComponent
  extends CurrentLocaleComponent
  implements OnInit, AfterViewInit, CockpitContentComponent
{
  card: CockpitCard;
  chart: Highcharts.Chart;

  isAbsolut = true;
  stacked = false;
  gesamtverdienstUndLohnbestandteile: GesamtverdienstUndLohnbestandteile;
  series: SeriesAbsolutPerc;
  crtSeries: string;
  gestapelt: string = GESTAPELT;
  ungestapelt: string = UNGESTAPELT;
  absolut: string = ABSOLUT;
  anteil: string = ANTEIL;

  constructor(
    @Inject(ChartTemplateService)
    private readonly chartTemplateService: ChartTemplateService,
    private readonly dataStorageService: DataStorageService,
    protected readonly translate: TranslateService,
    private readonly tableExport: TableExportService
  ) {
    super(translate);
    this.gesamtverdienstUndLohnbestandteile =
      new GesamtverdienstUndLohnbestandteile();
  }

  async ngOnInit() {
    super.ngOnInit();
    this.chartTemplateService.chartname = 'gesamtverdienstundlohnbestandteile';

    this.dataStorageService.getCockpitData().then(data => {
      this.gesamtverdienstUndLohnbestandteile = (
        data as Cockpit
      ).gesamtverdienstUndLohnbestandteile;
    });
  }

  ngAfterViewInit() {
    this.dataStorageService.getChartsData().then(data => {
      this.series = data.gesamtverdienstUndLohnbestandteile;

      this.initHighCharts(JSON.parse(this.series.seriesAbsolute));
      this.toggleDisplayChartSerie(this.chart);
    });

    this.translate.onLangChange.subscribe(() => {
      const svgContainer = document.getElementById(
        'svgContainerChartDialogGesamtverdienstLohnbestandteile'
      );
      if (svgContainer) {
        this.initHighCharts(JSON.parse(this.crtSeries));
        this.toggleDisplayChartSerie(this.chart);
      }
    });
  }

  exportChart() {
    this.chart.exportChart(
      {
        type: 'application/pdf',
        filename: 'my-pdf'
      },
      {}
    );
  }

  exportChartTable() {
    const cardTitle = this.translate.instant(
      'i18n.cockpit.card.GesamtverdienstLohn.title'
    );
    this.tableExport.exportHtmlTable(null, cardTitle);
  }

  selectionAbsolutAnteilChanged(item) {
    if (item.value === ABSOLUT) {
      this.isAbsolut = true;
    } else {
      this.isAbsolut = false;
    }
    this.toggleDisplayChartSerie(this.chart);
  }

  selectionGestapeltUngestepeltChanged(item) {
    if (item.value === GESTAPELT) {
      this.stacked = true;
    } else {
      this.stacked = false;
    }
    this.toggleDisplayChartSerie(this.chart);
  }

  private toggleDisplayChartSerie(chart: Highcharts.Chart) {
    this.intitializeChart();
    chart = this.chart;

    if (this.isAbsolut) {
      this.crtSeries = this.series.seriesAbsolute;
    } else {
      this.crtSeries = this.series.seriesPercent;
    }

    if (!chart.series) {
      this.initHighCharts(JSON.parse(this.crtSeries));
    }

    this.setDisplayInfoStackedCharts(chart);
  }

  private setDisplayInfoStackedCharts(chart: Highcharts.Chart) {
    let plotOptions = {};
    const title = this.isAbsolut
      ? this.translate.instant(
          'i18n.cockpit.card.chart.gesamtverdienstLohn.lohnbestandteileInCHF'
        )
      : this.translate.instant(
          'i18n.cockpit.card.chart.gesamtverdienstLohn.lohnbestandteileInPerzent'
        );

    const pointFormat = this.isAbsolut
      ? '<span style="color:{series.color}">{series.name}</span>: <span style="font-weight:bold;">{point.y}</span> CHF<br/>'
      : '<span style="color:{series.color}">{series.name}</span>: <span style="font-weight:bold;">{point.y}</span> %<br/>';

    const valueDecimals = this.isAbsolut ? 0 : 1;
    const tooltip = {
      pointFormat,
      valueDecimals
    };

    const max = this.isAbsolut ? null : 100;
    const labels = this.isAbsolut ? null : '{value}%';
    const ticks = this.isAbsolut ? null : 10;

    const yAxis = {
      min: 0,
      max,
      title: {text: ''},
      labels: {format: labels},
      tickInterval: ticks
    };

    const series = this.crtSeries
      ? JSON.parse(this.chartTemplateService.translateChart(this.crtSeries))
      : chart.options.series;
    if (this.stacked) {
      plotOptions = {
        plotOptions: {
          series: {stacking: 'normal'}
        },
        title: {
          text: title,
          style: {color: '#333333', fontSize: '16px'}
        },
        series,
        tooltip,
        yAxis
      };
    } else {
      plotOptions = {
        plotOptions: {
          series: {stacking: ''}
        },
        title: {
          text: title,
          style: {color: '#333333', fontSize: '16px'}
        },
        series,
        tooltip,
        yAxis
      };
    }
    chart.update(plotOptions, false);
    chart.reflow();
    chart.redraw();
  }

  private initHighCharts(series: string) {
    const xAxis = {
      categories: [
        this.translate.instant('i18n.common.frauen'),
        this.translate.instant('i18n.common.maenner')
      ]
    };
    const chartTitle = {
      text: this.translate.instant(
        'i18n.cockpit.card.chart.gesamtverdienstLohn.lohnbestandteileInCHF'
      ),
      style: {color: '#333333', fontSize: '16px'}
    };
    const yAxis = {
      labelsFormat: '{value}%',
      min: 0,
      max: null,
      tickInterval: null,
      titleText: ''
    };
    const legend = {reversed: true};
    const tooltip = {
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>: <span style="font-weight:bold;">{point.y}</span> CHF<br/>',
      valueDecimals: 0
    };

    this.chartTemplateService.initializeChartValues(
      series,
      chartTitle,
      xAxis,
      yAxis,
      legend,
      'normal',
      tooltip
    );

    this.intitializeChart();
  }

  private intitializeChart() {
    Highcharts.chart(
      'svgContainerChartDialogGesamtverdienstLohnbestandteile',
      this.chartTemplateService.json,
      thechart => {
        this.callBackFuncToNormalizeBarChart(thechart);

        // Observer pour détecter les changements de taille du conteneur
        const resizeObserver = new ResizeObserver(() => {
          if (this.chart) {
            this.chart.reflow();
          }
        });
        resizeObserver.observe(
          document.getElementById(
            'svgContainerChartDialogGesamtverdienstLohnbestandteile'
          )
        );
      }
    );
  }

  private callBackFuncToNormalizeBarChart(thechart: Highcharts.Chart) {
    this.chart = thechart;
  }
}
